<template>
    <div class="tab-body">
        <div class="rigth-panel-header"></div>
        <div class="rigth-panel-body">
            <div class="right-panel-section-header">
                <div class="right-panel-section-header-title">Account permissions</div>
                <div class="right-panel-section-header-option">
                </div>
            </div>
            <div class="right-panel-section-body">
                <div v-for="(item, index) in permissions" :key="index" class="permission-item"
                    v-if="user.account_type == item.account_type">
                    <div class="permission-item-name">{{ item.name }}</div>
                    <div class="permission-item-option">
                        <b-switch v-model="item.enabled" type="is-primary" rounded
                            @input="savePermission($event, item)"></b-switch>
                    </div>
                </div>
            </div>
        </div>
        <div class="rigth-panel-footer"></div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data: () => ({

    }),
    computed: {
        permissions() {
            return [
                {
                    name: "Video Storage",
                    permission_key: "video_storage",
                    enabled: false,
                    account_type: "streamer",
                },
                {
                    name: "Event Streaming",
                    permission_key: "event_streaming",
                    enabled: false,
                    account_type: "streamer",
                },
                {
                    name: "Tv Streaming",
                    permission_key: "tv_streaming",
                    enabled: false,
                    account_type: "streamer",
                },
                {
                    name: "Voting",
                    permission_key: "voting",
                    enabled: false,
                    account_type: "streamer",
                },
                {
                    name: "Events",
                    permission_key: "events",
                    enabled: false,
                    account_type: "streamer",
                },
                {
                    name: "Donation",
                    permission_key: "donation",
                    enabled: false,
                    account_type: "streamer",
                },
                // supper_admin
                {
                    name: "Dashboard",
                    permission_key: "dashboard",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
                {
                    name: "Messaging",
                    permission_key: "messaging",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
                {
                    name: "Finance",
                    permission_key: "finance",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
                {
                    name: "Ads",
                    permission_key: "ads",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
                {
                    name: "Channels",
                    permission_key: "channels",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
                {
                    name: "Tvs",
                    permission_key: "tvs",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
                {
                    name: "Members",
                    permission_key: "members",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
                {
                    name: "Settings",
                    permission_key: "settings",
                    enabled: false,
                    account_type: "wecodefystaff",
                },
            ].map(item => {
                const permission = this.user.permissions.find(permission => permission.permission_key === item.permission_key);
                item.enabled = permission ? permission.enabled == 1 ? true : false : false;
                return item;
            });
        },
    },
    watch: {},
    mounted() {

    },
    methods: {
        savePermission(status, item) {
            let vm = this;
            item.enabled = status;
            vm.$store
                .dispatch("ADMIN_USER_UPDATE_PERMISSIONS", {
                    user_id: vm.user.id,
                    permissions: vm.permissions,
                })
                .then((response) => {
                    vm.$emit("success");
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-success",
                    });
                })
                .catch(({ response }) => {
                    vm.$buefy.toast.open({
                        message: response.data.message,
                        type: "is-danger",
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.tab-body {
    height: calc(100% - 55px);
    display: flex;
    flex-direction: column;

    .rigth-panel-header {
        height: 0px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;
    }

    .rigth-panel-body {
        overflow-y: auto;
        height: calc(100% - 0px);

        .right-panel-section-header {
            background-color: #fff;
            padding: 0px 10px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #ddd;

            .right-panel-section-header-title {
                font-size: 16px;
                font-weight: 500;
            }

            .right-panel-section-header-option {
                display: flex;
            }
        }

        .right-panel-section-body {
            padding: 10px;
        }

        .permission-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0px;

            .permission-item-name {
                font-size: 14px;
                font-weight: 500;
            }

            .permission-item-option {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }

    .rigth-panel-footer {
        height: 0px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #ddd;
    }
}
</style>